import React from 'react';
import { Link } from 'react-router-dom';
// 1. Import icons from react-icons
import { 
  HiHome, 
  HiViewGrid, 
  HiUsers, 
  HiDocumentText, 
  HiAnnotation, 
  HiPlusCircle 
} from 'react-icons/hi';

const AdminDrawer = ({ isOpen, setIsOpen }) => {
  // A helper function to close the drawer on mobile when a link is clicked
  const handleLinkClick = () => {
    if (window.innerWidth < 768) { // md breakpoint in Tailwind
      setIsOpen(false);
    }
  };

  return (
    <div 
      style={{ minHeight: "100vh" }} 
      className={`fixed top-0 left-0 h-full w-64 bg-gray-800 text-white transform ${isOpen ? 'translate-x-0' : '-translate-x-full'} transition-transform duration-300 ease-in-out z-30 md:relative md:translate-x-0`}
    >
      <div className="flex items-center justify-center h-16 bg-gray-900 text-xl font-bold">
        Admin Panel
      </div>
      <nav className="flex flex-col p-4 space-y-2">
        <Link to="/" className="flex items-center gap-3 text-lg hover:bg-gray-700 p-2 rounded" onClick={handleLinkClick}>
          <HiHome size={24} />
          <span>Home</span>
        </Link>
        <Link to="/admin/blogs-manage" className="flex items-center gap-3 text-lg hover:bg-gray-700 p-2 rounded" onClick={handleLinkClick}>
          <HiDocumentText size={24} />
          <span>Manage Blogs</span>
        </Link>
        <Link to="/admin/category" className="flex items-center gap-3 text-lg hover:bg-gray-700 p-2 rounded" onClick={handleLinkClick}>
          <HiViewGrid size={24} />
          <span>Category</span>
        </Link>
        {/* <Link to="/admin/users" className="flex items-center gap-3 text-lg hover:bg-gray-700 p-2 rounded" onClick={handleLinkClick}>
          <HiUsers size={24} />
          <span>Manage Users</span>
        </Link> */}
        <Link to="/admin/comments-manage" className="flex items-center gap-3 text-lg hover:bg-gray-700 p-2 rounded" onClick={handleLinkClick}>
          <HiAnnotation size={24} />
          <span>Manage Comments</span>
        </Link>
        <Link to="/admin/blogs-create" className="flex items-center gap-3 text-lg hover:bg-gray-700 p-2 rounded" onClick={handleLinkClick}>
          <HiPlusCircle size={24} />
          <span>Create Blog</span>
        </Link>
         <Link to="/admin/carousel" className="flex items-center gap-3 text-lg hover:bg-gray-700 p-2 rounded" onClick={handleLinkClick}>
          <HiPlusCircle size={24} />
          <span>Carousel</span>
        </Link>
      </nav>
    </div>
  );
};

export default AdminDrawer;